import React from 'react';
import { Modules } from '~/lib/data-contract';
import { DynamicBlock } from '../DynamicBlock';

type Props = {
    elements: Modules[];
    preventPriority?: boolean;
    isSkipShown?: boolean;
};

export const DynamicBlockList = ({ elements, preventPriority, isSkipShown }: Props) => {
    if (!elements?.length) return null;

    return (
        <>
            {elements.map((element, index) => {
                const isLastItem = index === elements.length - 1;

                return (
                    <section key={element.id} tabIndex={0} data-dynamic-block>
                        <DynamicBlock
                            element={element}
                            index={index}
                            priority={preventPriority ? false : index < 3}
                            isLastItem={isSkipShown ? !isSkipShown : isLastItem}
                        />
                    </section>
                );
            })}
        </>
    );
};
